import { render } from "./FormGeneralFields.vue?vue&type=template&id=483ee200&scoped=true"
import script from "./FormGeneralFields.vue?vue&type=script&lang=js"
export * from "./FormGeneralFields.vue?vue&type=script&lang=js"

import "./FormGeneralFields.vue?vue&type=style&index=0&id=483ee200&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483ee200"]])

export default __exports__